module.exports = __webpack_public_path__ + "static/media/2c.51f801fd.jpg";